import EnableReservationSettings from './EnableReservationSettings';
import NotificationEmailField from './NotificationEmailField';

export default {
  EnableReservationSettings,
  NotificationEmailField,
};
